<nav class="flex items-center text-sm text-gray-600 mb-4 overflow-hidden" aria-label="Breadcrumb">
  <a [routerLink]="['/apps']" class="hover:text-main transition-colors mr-2" aria-label="Home">
    <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20">
      <path
        d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
    </svg>
  </a>
  @if (breadcrumbs$ | async; as breadcrumbs) {
    @if (breadcrumbs.length > 0) {
      <span class="text-gray-400 mr-2">/</span>
    }
    @for (breadcrumb of breadcrumbs; track breadcrumb.url; let isLast = $last) {
      @if (!isLast) {
        <a
          [routerLink]="breadcrumb.url"
          class="hover:text-main transition-colors shrink-0 inline-flex items-center mr-2"
          [title]="breadcrumb.label">
          @if (breadcrumb.iconDataUrl) {
            <img
              [src]="breadcrumb.iconDataUrl"
              [alt]="breadcrumb.label"
              class="w-5 h-5 mr-1 fill-current" />
          }
          <span>{{ breadcrumb.label }}</span>
        </a>
        <span class="text-gray-400 mr-2">/</span>
      } @else {
        <div
          class="text-gray-900 font-medium inline-flex items-center min-w-0"
          [title]="breadcrumb.label">
          @if (breadcrumb.iconDataUrl) {
            <img
              [src]="breadcrumb.iconDataUrl"
              [alt]="breadcrumb.label"
              class="w-5 h-5 mr-1 shrink-0 fill-current" />
          }
          <span class="truncate">{{ breadcrumb.label }}</span>
        </div>
      }
    }
  }
</nav>
